const URL_OPEN_WIDGET_KEY = 'remark_open';
export const shouldStartOpen = () => {
  const widgetOpen = new URLSearchParams(window.location.search).get(URL_OPEN_WIDGET_KEY);
  return widgetOpen === 'true';
};
